import { message, Modal } from 'antd'
import serviceInterface from '../../services/service.interface'
import ActionType from '../action.types'
import { count, dispatch } from 'd3'
import { operationInProgress as isLoading } from '../action/profile.action'
import moment from 'moment'

/*
Actions to be dispatched for regimen
- Inprogress
    action to dispatch incase of operation in progress
- set devices
    action to dispatch incase to push assigned regs
*/

export function operationInProgress(isLoading) {
  return {
    type: ActionType.DEVICE_INPROGRESS,
    isLoading,
  }
}

export function assignDevices(devices) {
  return {
    type: ActionType.DEVICE_SET_ASSIGNED,
    devices,
  }
}
export function assignPlan(plan) {
  console.log('plan assignPlan---------->>', plan)
  return {
    type: ActionType.PLAN_SET_ASSIGNED,
    plan,
  }
}

export function setDevices(devices) {
  return {
    type: ActionType.DEVICE_SET_DEVICE,
    devices,
  }
}
export function setUserLocation(deviceData) {
  return {
    type: ActionType.DEVICE_LOCATION,
    deviceData,
  }
}


export function setcareplans(careplans) {
  console.log('careplans   setcareplans----->>', careplans)
  return {
    type: ActionType.DEVICE_SET_PLANS,
    careplans,
  }
}
export function setFullfillments(fullfillments, filter, fullfillmentSorter) {
  return {
    type: ActionType.DEVICE_SET_FULLFILLMENTS,
    fullfillments,
    fullfillmentFilter: filter,
    fullfillmentSorter,
  }
}

export function setFullfillmentFilter(filter) {
  return {
    type: ActionType.DEVICE_SET_FULLFILLMENT_FILTER,
    fullfillmentFilter: filter,
  }
}

export function setFullfillmentsCount(count) {
  return {
    type: ActionType.DEVICE_SET_FULLFILLMENTS_COUNT,
    fuifillmentCount: count,
  }
}
export function setFullfillmentDevices(fullfillmentDevices) {
  return {
    type: ActionType.DEVICE_SET_FULLFILLMENT_DEVICES,
    fullfillmentDevices,
  }
}

export function getAllDevices(arg) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))

      let data = await serviceInterface.DeviceService().getAllDevices(arg)
      console.log('GetAllldevices', data)
      dispatch(operationInProgress(false))
      if (data.error !== undefined && !data.error) message.error(data.message)
      else {
        dispatch(setDevices(data.getAllDevices))
        return data.getAllDevice
      }
    } catch (err) {
      dispatch(operationInProgress(false))
    }
  }
}
export function getAllCarePlans(arg) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))

      let data = await serviceInterface.DeviceService().getAllCarePlans(arg)
      dispatch(operationInProgress(false))
      if (data.error !== undefined && !data.error) message.error(data.message)
      else {
        dispatch(setcareplans(data.getAllCarePlans))
      }
    } catch (err) {
      dispatch(operationInProgress(false))
    }
  }
}

export function updateDeviceSchedule({ patient, devices, reorder = false }) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .DeviceService()
        .updateDeviceSchedule({ patient, devices, reorder })
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      console.log(err)
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}

export function getFullfillmentsCount(input) {
  return async (dispatch) => {
    try {
      //dispatch(operationInProgress(true));
      let data = await serviceInterface
        .DeviceService()
        .getFullfillmentsCount(input)
      //dispatch(operationInProgress(false));
      if (data.error) message.error("Server error: can't fetch data")
      else {
        dispatch(setFullfillmentsCount(data?.data))
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error("Server Exception: can't fetch data")
      //dispatch(operationInProgress(false));
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}

export function getFullfillments(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().getFullfillments(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error("Server error: can't fetch data")
      else {
        dispatch(
          setFullfillments(
            { list: data?.data, total: data?.total, metadata: input.metadata },
            input.filters,
            input.sorter
          )
        )
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error("Server Exception: can't fetch data")
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function getFullfillmentViewDevices(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .DeviceService()
        .getFullfillmentViewDevices(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        dispatch(setFullfillmentDevices(data?.data))
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function updateDeviceOrder(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().updateDeviceOrder(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function markAsShipped(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().markAsShipped(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      dispatch(operationInProgress(false))
      const errorMsg = err?.message || 'Failed to ship devices'
      Modal.error({
        title: 'Device Registration Failed',
        content: errorMsg,
        width: 520,
      })
    }
  }
}
export function markAsDeleted(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().markAsDeleted(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function updateTrackingLink(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .DeviceService()
        .updateTrackingLink(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function updateGatewayId(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().updateGatewayId(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        //  message.success(data.message);
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function updateTracPatchFulfillment(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().updateTracPatchFulfillment(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        message.success('TracPatch details saved')
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
    }
  }
}

export function updateAddress(input) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().updateAddress(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        message.success(data.message)
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
export function getRangeMeasurement({
  patientid,
  deviceid,
  startdate,
  enddate,
}) {
  console.log(patientid, deviceid, startdate, enddate, 'oooo')
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .DeviceService()
        .getRangeMeasurement(patientid, deviceid, startdate, enddate)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        return data.getRangeMeasurement
      }
    } catch (err) {
      console.log(err)
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}

export function getDeviceSchedule(patientid) {
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface
        .DeviceService()
        .getDeviceSchedule(patientid)

      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        if (!data.getDeviceSchedule) return dispatch(assignDevices([]))
        var formattedDevices = data.getDeviceSchedule.assigneddevices.map(
          (dev, i) => {
            dev._id = dev.deviceid
            let sched_temp = data.getDeviceSchedule?.scheduletemplate?.filter(
              (sch) => sch.deviceid == dev.deviceid
            )
            dev.scheduled_criteria = {
              end_date: sched_temp[0].enddate,
              start_date: sched_temp[0].startdate,
              interval: sched_temp[0].interval,
              time: sched_temp[0].time,
              skiponsurgerydate: sched_temp[0].skiponsurgerydate
            }
            delete dev.deviceid
            return dev
            // return {
            //     ...dev,
            //         _id:dev.deviceid,
            //          scheduled_criteria:{
            //         end_date:data.getDeviceSchedule.scheduletemplate[i].enddate,
            //         start_date:data.getDeviceSchedule.scheduletemplate[i].startdate,
            //         time:data.getDeviceSchedule.scheduletemplate[i].time
            //     }

            // }
          }
        )
        dispatch(assignDevices(formattedDevices))
      }
    } catch (err) {}
  }
}

export function getGraphMeasurementData(pid, did, count) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true))
      let data = await serviceInterface
        .DeviceService()
        .getGraphMeasurementData(pid, did, count)
      dispatch(isLoading(false))
      if (data.error) message.error(data.message)
      else {
        return data
      }
    } catch (err) {
      console.log(err)
      message.error(err?.message)
      dispatch(isLoading(false))
    }
  }
}

export function setUserDeviceToken(input) {
  const token = localStorage.getItem('deviceToken')

  if (!token) return
  input.timezone= moment().utcOffset();
  input.token=token;
  return async (dispatch) => {
    try {
      dispatch(operationInProgress(true))
      let data = await serviceInterface.DeviceService().setUserDeviceToken(input)
      dispatch(operationInProgress(false))
      if (data.error) message.error(data.message)
      else {
        return true
      }
    } catch (err) {
      message.error(err?.message)
      dispatch(operationInProgress(false))
      // dispatch(serviceError(true, 'error communicating with the server'));
    }
  }
}
